import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Tags } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { DateLike, formatVatDate } from "./vatReportModel";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

interface VatReportDueDateProps {
  dueDate: DateLike;
  isOverdue: boolean;
}

// The red "Betalning försenad" tag is what carries the error colour: the app has no error-coloured text
// style for a table cell or a details value, and Tags is its badge primitive.
const VatReportDueDate: React.FC<VatReportDueDateProps> = ({ dueDate, isOverdue }) =>
  isOverdue ? (
    <Grid container spacing={1} alignItems="center" wrap="nowrap">
      <Grid item>{formatVatDate(dueDate)}</Grid>
      <Tags
        tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.VatReportOverdue)]}
        className={cssExports.redTag}
      />
    </Grid>
  ) : (
    <>{formatVatDate(dueDate)}</>
  );

export default VatReportDueDate;
